<template>
    <div class="w-full md:w-fit">
        <Button
            as="a"
            target="_blank"
            :href="
                urlFactory.makeGuestMeetingViewPageUrl(
                    meeting.bookingId,
                    reservationData.reservation.companyCustomerId,
                )
            "
            :disabled="attendanceData.attendance.cannotCancel"
            color="danger-outline"
            size="small"
            iconName="close-circle"
            iconClass="w-4 h-4"
            class="w-full"
        >
            Cancel
        </Button>
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { type PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import Meeting from '@/App/Booking/Meeting/Entity/Meeting'
    import AttendanceData from '@/App/Booking/Attendance/Entity/AttendanceData'
    import ReservationData from '@/App/Booking/Reservation/Entity/ReservationData'

    const props = defineProps({
        meeting: {
            type: Object as PropType<Meeting>,
            required: true,
        },
        attendanceData: {
            type: Object as PropType<AttendanceData>,
            required: true,
        },
        reservationData: {
            type: Object as PropType<ReservationData>,
            required: true,
        },
    })
    const urlFactory = new UrlFactory()
</script>
